var _style, _rect, _line, _line2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserInterfaceAndUserExperienceResponsiveImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 384.5,
    className: "st0",
    width: 279.5,
    height: 295.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 393.5,
    y1: 384.5,
    x2: 673,
    y2: 680
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 673,
    y1: 384.5,
    x2: 393.5,
    y2: 680
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 416.4,
    y: 712,
    width: 233.8,
    height: 24.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInterfaceAndUserExperienceResponsiveImage);
export default __webpack_public_path__ + "static/media/User-Interface-and-User-Experience-Responsive-Image.eaab8d20cfad4e0881a0b0a36bd4bdd8.svg";
export { ForwardRef as ReactComponent };